export interface FormatDateOptions {
    /** BCP 47 language, e.g. the site language `es`. */
    locale: string;
    /** IANA time zone, e.g. `America/Mexico_City`. */
    timeZone: string;
    /** @default 'medium' */
    dateStyle?: Intl.DateTimeFormatOptions['dateStyle'];
}

/**
 * A date in an explicit language and time zone. Never rely on the runtime's defaults: the server and the browser
 * have different ones (docs/guides/m1work-shared-utils.md#dates-and-time-zones). An invalid date gives `''`.
 */
export function formatDate(
    value: string | Date,
    { locale, timeZone, dateStyle = 'medium' }: FormatDateOptions,
): string {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return new Intl.DateTimeFormat(locale, { timeZone, dateStyle }).format(date);
}
